/**
 * Store: Quick view
 * -----------------------------------------------------------------------------
 * Tracks what product handle should be displayed in quick view modal.
 *
 */
export default {
  namespaced: true,

  state: () => ({
    handle: '',
    nostoResultId: '',
  }),

  mutations: {

    /**
     * Set quick view handle.
     * @param {String} handle - Product handle.
     */
    SET_HANDLE(state, handle) {
      state.handle = handle
    },

    /**
     * Set quick view nosto result id.
     * @param {String} nostoResultId - Nosto result id.
     */
    SET_NOSTO_RESULT_ID(state, nostoResultId) {
      state.nostoResultId = nostoResultId
    },
  },

  actions: {

    /**
     * Set quick view handle.
     * @param {String} handle - Product handle.
     */
    setHandle({ commit, dispatch }, { handle = '', resultId }) {
      commit('SET_HANDLE', handle)
      commit('SET_NOSTO_RESULT_ID', resultId)

      /**
       * Open quick view overlay if setting a handle.
       */
      if (!handle) {
        return
      }

      const data = {
        component: 'quick-view',
        ignoreDismissed: true,
        namespace: 'quickView',
      }

      dispatch('overlays/open', data, { root: true })
    },
  },
}
